/**
 * Wave-2 — a shared, client-side facet toolbar for the history/log surfaces
 * (LinkedIn engagement · Job changes · Connection requests · Automation log).
 * Each surface returns ≤50-100 rows, so filtering is pure-client (a search box +
 * chip groups over the already-loaded array) — no API change. Reuses the existing
 * `.queue-chip` styling for the chips.
 */
export interface FacetGroup {
  label: string;
  /** The selected option value, or null for "All". */
  value: string | null;
  options: ReadonlyArray<{ value: string; label: string }>;
  onChange: (v: string | null) => void;
}

export function HistoryFacets({
  search,
  onSearch,
  placeholder = 'Search by name…',
  groups = [],
  shown,
  total,
}: {
  search: string;
  onSearch: (v: string) => void;
  placeholder?: string;
  groups?: FacetGroup[];
  shown: number;
  total: number;
}) {
  return (
    <div className="history-facets" data-testid="history-facets">
      <input
        type="search"
        className="history-facets-search"
        value={search}
        onChange={(e) => onSearch(e.target.value)}
        placeholder={placeholder}
        aria-label="Search history by name"
      />
      {groups.map((g) => (
        <div key={g.label} className="queue-chips history-facet-group">
          <span className="history-facet-label">{g.label}</span>
          <button
            type="button"
            className={g.value === null ? 'queue-chip active' : 'queue-chip'}
            onClick={() => g.onChange(null)}
          >
            All
          </button>
          {g.options.map((o) => (
            <button
              key={o.value}
              type="button"
              className={g.value === o.value ? 'queue-chip active' : 'queue-chip'}
              // toggle off if re-clicked, so a chip is its own clear.
              onClick={() => g.onChange(g.value === o.value ? null : o.value)}
            >
              {o.label}
            </button>
          ))}
        </div>
      ))}
      <span className="history-facets-count" data-testid="history-facets-count">
        {shown === total ? `${total}` : `${shown} of ${total}`}
      </span>
    </div>
  );
}
